import { MarketSignalAlarmConfig } from '@/modules/market-signals/model/market-signals/market-signal-alarm-config';

export default function MarketSignalAlarmType({ alarm }: { alarm: MarketSignalAlarmConfig }) {
  if (alarm.type === 'llm')
    return <span className={'badge bg-warning-subtle text-warning-emphasis'}>LLM Analysis</span>;
  if (alarm.condition === '*')
    return <span className={'badge bg-danger-subtle text-danger-emphasis'}>Stream Monitor</span>;
  return <span className={'badge bg-info-subtle text-info-emphasis'}>Text Search</span>;
}
